import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30e29ddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0" }
const _hoisted_2 = { class: "d-flex flex-column gap-3" }
const _hoisted_3 = { class: "d-flex p-3 rounded gap-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"border-radius":"50%","height":"3rem"},
    src: "https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg",
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "p-0 w-100" }
const _hoisted_6 = { class: "my-3" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex gap-3 rounded p-3",
  style: {"background-color":"#f9f9f9"}
}
const _hoisted_8 = { class: "demo-image__preview d-flex gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayComments, (comment, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "rounded",
          key: key,
          style: {"background-color":"#ffffff"}
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(comment.username.split(' ').length > 2 ? `${comment.username.split(' ')[0]} ${comment.username.split(' ')[1]}` : comment.username), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("p", _hoisted_6, _toDisplayString(comment.description), 1),
              (comment.urls && comment.urls.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.urls, (item, key) => {
                        return (_openBlock(), _createBlock(_component_el_image, {
                          class: "rounded",
                          key: key,
                          style: {"width":"100px","height":"100px","cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.getUrls(comment.urls)),
                          src: item.url,
                          "zoom-rate": 1.2,
                          "max-scale": 7,
                          "min-scale": 0.2,
                          "preview-src-list": _ctx.arrayUrls,
                          "initial-index": key,
                          fit: "cover"
                        }, null, 8, ["onClick", "src", "preview-src-list", "initial-index"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}